export default __webpack_public_path__ + "static/media/gamification-img.e563a21a.png";